import { FormattedNumber } from 'react-intl';
import { styled } from 'styled-components';

const GreyText = styled.span`
  color: var(--c-neutral-600);
`;
const BrandText = styled.span`
  color: var(--c-brand-600);
  font-weight: var(--t-bold);
`;

export const LineupCount = ({
  count,
  compact = false,
}: {
  count: number;
  compact?: boolean;
}) => {
  return (
    <FormattedNumber
      value={count}
      notation={compact ? 'compact' : 'standard'}
    />
  );
};

const DidNotPlay = () => <GreyText>-</GreyText>;

export const Ranking = ({
  rank,
  count,
  compact = false,
}: {
  rank: number | undefined;
  count: number;
  compact?: boolean;
}) => {
  return (
    <span>
      {rank ? (
        <BrandText>
          <FormattedNumber value={rank} />
        </BrandText>
      ) : (
        <DidNotPlay />
      )}
      /
      <LineupCount count={count} compact={compact} />
    </span>
  );
};
